import React, { Component } from 'react';

import AvisInformacioAddicionalComentarisLlista from './avisInformacioAddicionalComentarisLlista';
import AvisInformacioAddicionalComentarisInserir from './avisInformacioAddicionalComentarisInserir';
import errorBoundaryWrapper from '../commons/errorBoundaryWrapper';
import seguretatWrapper from '../seguretat/seguretatWrapper';
import { esPotInserirComentari } from '../../commons/callbacksSeguretat';

class AvisInformacioAddicionalComentaris extends Component {

    render() {

        const InserirComentariAmbSeguretat = seguretatWrapper(AvisInformacioAddicionalComentarisInserir, esPotInserirComentari);

        return (
            <div>
                <AvisInformacioAddicionalComentarisLlista />
                <InserirComentariAmbSeguretat />
            </div>
        );
    }
}

export default errorBoundaryWrapper(AvisInformacioAddicionalComentaris);


// WEBPACK FOOTER //
// ./src/components/avis/avisInformacioAddicionalComentaris.js